module.exports = "<p-messages [(value)]=\"msgs\"></p-messages>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/g-message/g-message.component.html
// module id = ../../../../../src/app/shared/component/g-message/g-message.component.html
// module chunks = main